import React, { useEffect } from 'react';
import { useStore } from '../../../../../../stores/root';
import styles from './styles.module.scss';
import { SpinnerSize, Stack } from '@fluentui/react';
import LoadingComponent from '../../../../../feedbacks/loading';
import Label from '../../../../../typography/label';
import GeneralService from '../../../../../../services/general';
import { IIncomeInvoiceResourceShortProps } from '../../../../../../props/finance/incomes/invoices/invoice';

type TotalIncomeInvoiceUnpaidAmountCardProps = {
    style?: any;
    grow?: number | boolean | "inherit" | "initial" | "unset" | undefined;
    variant?: 'primary' | 'default';
    invoices?: IIncomeInvoiceResourceShortProps[];
}

const TotalIncomeInvoiceUnpaidAmountCard: React.FC<TotalIncomeInvoiceUnpaidAmountCardProps> = (props: TotalIncomeInvoiceUnpaidAmountCardProps) => {
    const { banner } = useStore();
    const [unpaidAmount, setUnpaidAmount] = React.useState<number>();

    useEffect(() => {
        calculateUnpaidAmount();
    }, [props.invoices]);

    const calculateUnpaidAmount = () => {
        let totalAmount = 0;

        (props.invoices || []).forEach((invoice) => {
            totalAmount += Number(invoice.unpaid || '0');
        });

        setUnpaidAmount(totalAmount);
    }

    return <Stack grow={props.grow} tokens={{ childrenGap: 20 }} className={`${styles.card} ${styles.variant}`} style={props.style}>
        <Stack>
            <Label size={'small'}>Unpaid amount</Label>
        </Stack>
        <Stack>
            {!props.invoices ? <LoadingComponent labelPosition='right' label={'Retrieving ...'} spinnerPosition={'baseline'} size={SpinnerSize.small} /> : null}
            {props.invoices ? <>
                <Label className={'color-red'} size={'large'}>Rp. {GeneralService.getNumberWithSeparator(unpaidAmount + '')}</Label>
            </> : null}
        </Stack>
    </Stack>;
};

export default TotalIncomeInvoiceUnpaidAmountCard;
